import { CALL_API } from "../api.middleware";
import {
  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILED,
  USER_LOGOUT,
  USER_PAN,
  POSTER_OPEN,
  USER_LOGIN_REFRESH_SUCCESS,
} from "../types/auth";

export const PosterOpen = (value) => {
  return {
    type: POSTER_OPEN,
    body: value,
  };
};

export const userLogin = (body) => async (dispatch) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: "/login",
        body,
        method: "POST",
        isLogin: true,
      },
    });
    if (response?.code === "SKIP_DIST_LOGIN") {
      dispatch({
        body: response,
        type: USER_LOGIN_SUCCESS,
      });
    }
    return response;
  } catch (error) {
    return error;
  }
};
export const validateOTP = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/validate-otp",
        body,
        method: "POST",
        types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAILED],
        isLogin: true,
      },
    });
  } catch (error) {
    alert(error);
  }
};

export const refreshToken = () => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/refresh_token",
        method: "GET",
        types: ["", USER_LOGIN_REFRESH_SUCCESS],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

// export const userLogin = (params) => async (dispatch) => {
//   try {
//     return await dispatch({
//       [CALL_API]: {
//         url: "/GetUserLoginnew_v17",
//         params,
//         method: "GET",
//         types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAILED],
//       },
//     });
//   } catch (error) {
//     alert(`${error}`);
//   }
// };

export const generateOtp = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/generate-signupotp",
        body,
        method: "POST",
        isAuth: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const reGenerateOtp = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/regenerate-signupotp",
        body,
        method: "POST",
        isAuth: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const registration = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/validate-signupotp",
        body,
        method: "POST",
        isAuth: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const forgotUserId = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetForgotUsername",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    // alert(`${error}`);
    console.log(error);
  }
};

export const forgotPassword = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetForgotPassword",
        params,
        method: "GET",
        isAuth: true,
        showLoader:true
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const resetPassword = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ResetPassword",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const userLogout = () => {
  return {
    type: USER_LOGOUT,
  };
};

export const userPan = (Pan) => {
  return {
    type: USER_PAN,
    body: Pan,
  };
};

// export const FundCodes = () => async dispatch =>{
//   try{
//     return await dispatch({

//     })
//   }catch (error) {
//     alert(`${error}`);
//   }
// }

export const generateLoginOtp = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GenerateLoginOTP",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
export const validateLoginOtp = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ValidateLoginOTP",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
export const SaveEmailMobile_Login = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SaveEmailMobile_Login",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
export const SendOtp_EmailorMOB = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SendOtp_EmailorMOB",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
export const Verify_EmailorMOB = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Verify_EmailorMOB",
        params,
        method: "GET",
        isAuth: true,
      },
    });
  } catch (error) {
    return { error };
  }
};
export const validatForgotOtp = (body) => async (dispatch) => {
  try {
  return await dispatch({
    [CALL_API]: {
      url: "/validate-forgot-otp",
      body,
      method: "POST",
      showLoader: true,
      isAuth: true,
    },
  });
} catch (error) {
  return { error };
}
};
